import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import * as FileSaver from "file-saver";
import { NgxSpinnerService } from "ngx-spinner";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { CrudComponent } from "src/app/components/shared/cruds/crud.component";
import { WorkersActions } from "src/app/models/alias";
import { Condition } from "src/app/models/custom-types";
import { TrabajadorSimpleDTO } from "src/app/models/dto/trabajador-simple.dto";
import { TrabajadorDTO } from "src/app/models/dto/trabajador.dto";
import { FilterEvent } from "src/app/models/filter";
import { BajaTrabajadorForm } from "src/app/models/forms/baja-trabajador.form";
import { TrabajadorForm } from "src/app/models/forms/trabajador.form";
import { ListAction } from "src/app/models/list-actions.model";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { DrawerService } from "src/app/services/drawer.service";
import { FabButtonService } from "src/app/services/fab-button.service";
import { PermisosService } from "src/app/services/permisos.service";
import { Filter } from "src/app/shared/classes/filter";
import { SweetAlertOptions } from "sweetalert2";
import { HistorialAsignacionesModal } from "./assings/modal.component";
import { BajaOperadorFormModal } from "./baja/baja.component";
import { TrabajadorDrawerForm } from "./drawer-form/drawer-form.component";
import { HistorialReingresosModal } from "./historial/modal.component";
import { OperadoresService } from "./operadores.service";
import { TrabajadorResumeComponent } from "./resume/resume.component";

@Component({
  selector: "app-operadores",
  templateUrl: "./operadores.component.html",
  styles: [],
})
export class OperadoresComponent extends CrudComponent<any> implements OnInit{
  protected useFilterInactive: boolean = true;
  columnId: string = "IdTrabajador";
  public columns: ListColumn[] = [
    {
      name: "Nombre",
      property: "Nombre",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Telefono",
      property: "Telefono",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Direccion",
      property: "Direccion",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Tipo",
      property: "TipoDesc",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];

  public columnsWOActions: ListColumn[] = [
    {
      name: "Nombre",
      property: "Nombre",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Telefono",
      property: "Telefono",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Direccion",
      property: "Direccion",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Tipo",
      property: "TipoDesc",
      visible: true,
      isModelProperty: true,
    },
  ];

  public actions: ListAction<TrabajadorDTO>[] = [
    {
      desc: "Actualizar",
      action: "update",
      visible: () => true,
    },
    {
      desc: "Ver datos generales",
      action: "resume",
      visible: () => true,
    },
    {
      desc: "Dar de baja",
      action: "remove",
      visible: () => true,
    },
    {
      desc: "Descargar acta seguro",
      action: "download",
      visible: () => true,
    },
    {
      desc: "Historial de ingreso",
      action: "logs",
      visible: () => true,
    },
    {
      desc: "Historial de asignaciones",
      action: "assigns",
      visible: () => true,
    },
  ];

  public actionsBaja: ListAction<TrabajadorSimpleDTO>[] = [
    {
      desc: "Ver datos generales",
      action: "resume",
      visible: () => true,
    },
    {
      desc: "Reingresar",
      action: "activate",
      visible: (row) => !row[this.columnActive],
    },
    {
      desc: "Descargar baja seguro",
      action: "download2",
      visible: () => true,
    },
    {
      desc: "Historial de ingreso",
      action: "logs",
      visible: () => true,
    },
  ];

  public actionsNoReingresos: ListAction<TrabajadorSimpleDTO>[] = [
    {
      desc: "Ver datos generales",
      action: "resume",
      visible: () => true,
    },
    {
      desc: "Descargar baja seguro",
      action: "download2",
      visible: () => true,
    },
    {
      desc: "Historial de ingreso",
      action: "logs",
      visible: () => true,
    },
  ];

  @ViewChild("CardTableComponent", { static: true })
  public tableComp: CardTableComponent;

  @ViewChild("CardTableComponentBajas", { static: true })
  public tableCompBajas: CardTableComponent;

  @ViewChild("CardTableComponentNo", { static: true })
  public tableCompNo: CardTableComponent;

  filtro: string = "";
  realdata: TrabajadorDTO[];
  realdataNo: TrabajadorSimpleDTO[];
  realdataBajas: TrabajadorSimpleDTO[];
  askModalBajaConfig: SweetAlertOptions = {
    title: "Seguro que quieres dar de b.aja este chofer?",
    text: "Esta accion es irreversible!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si",
    cancelButtonText: "No",
  };

  constructor(
    public service: OperadoresService,
    public spinner: NgxSpinnerService,
    public dialog: MatDialog,
    public permisoServ: PermisosService,
    public alerts: AlertasSwalService,
    public fab : FabButtonService,
    public drawer: DrawerService
  ) {
    super(service, alerts);
    this.filter = new Filter<TrabajadorSimpleDTO>(
      this.conditions,
      this.columns,
      true
    );
    this.filterNo = new Filter<TrabajadorSimpleDTO>(
      this.conditions,
      this.columns,
      true
    );
    this.filterBajas = new Filter<TrabajadorSimpleDTO>(
      this.conditions,
      this.columns,
      true
    );
  }

  btnAgregar = {
    backgroundClass: "bg-blue-500 hover:w-52",
    iconClass: "fas fa-plus",
    title: "Agregar trabajador",
    action: () => {
      this.formulario.setCreate();
    },
  };
  ngOnInit(): void {
    this.Init();
  }

  preLoadRecords() {
    const permisos = this.permisoServ.getPermisos();
    if (permisos.includes("spcl_worker_reingreso")) {
      this.actionsNoReingresos = [
        {
          desc: "Reingresar",
          action: "activate",
          visible: (row) => !row[this.columnActive],
        },
        ...this.actionsNoReingresos,
      ];
    }
  }

  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData.map(mapperTrabajador);
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );

    this.service.getBajas().subscribe(
      (resultData) => {
        this.realdataBajas = resultData.map(mapperTrabajadorSimple);
        this.filterBajas.setDataTable(this.realdataBajas, this.tableCompBajas);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );

    this.service.getNoReingreso().subscribe(
      (resultData) => {
        this.realdataNo = resultData.map(mapperTrabajadorSimple);
        this.filterNo.setDataTable(this.realdataNo, this.tableCompNo);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
  //#region Filter

  public filter: Filter<TrabajadorSimpleDTO>;
  public filterNo: Filter<TrabajadorSimpleDTO>;
  public filterBajas: Filter<TrabajadorSimpleDTO>;
  public conditions: Condition<TrabajadorSimpleDTO> = {
    Telefono: (o, f) => (o.Telefono ?? "").toLocaleLowerCase().indexOf(f) > -1,
    Nombre: (o, f) => (o.Nombre ?? "").toLocaleLowerCase().indexOf(f) > -1,
    Direccion: (o, f) =>
      (o.Direccion ?? "").toLocaleLowerCase().indexOf(f) > -1,
    TipoDesc: (o, f) => (o.TipoDesc ?? "").toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }
  filterdataNo(e: FilterEvent) {
    this.filterNo.filterdata(e, this.realdataNo, this.tableCompNo);
  }
  filterdataBaja(e: FilterEvent) {
    this.filterBajas.filterdata(e, this.realdataBajas, this.tableCompBajas);
  }

  //#endregion Filter
  saveForm(e: { mode: string; value: TrabajadorForm; file: File }) {
    if (e.mode == "create") {
      if (e.file) this.guardarConImagen(e.value, e.file);
      else this.guardar(e.value);
    } else if (e.mode == "update") {
      if (e.file) this.actualizarConImagen(e.value, e.file);
      else this.actualizar(e.value);
    }
  }

  guardarConImagen(row: TrabajadorForm, imagen: File) {
    this.service.addWithFile(row, imagen).subscribe(
      (next) => {
        this.alerts.correcta("Creado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  actualizarConImagen(row: TrabajadorForm, imagen: File) {
    this.service.updateWithFile(row, imagen).subscribe(
      (next) => {
        this.alerts.correcta("Actualizado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
  actionstable(e: { action: WorkersActions; row: TrabajadorDTO }) {
    if (e.action == "update") {
      this.openEdit(e.row);
      this.formulario.setUpdate(e.row);
    } else if (e.action == "activate") {
      this.activar(e.row);
    } else if (e.action == "download") {
      this.downLoad(e.row.IdTrabajador, e.row.Nombre);
    } else if (e.action == "download2") {
      this.downLoadBaja(e.row.IdTrabajador, e.row.Nombre);
    } else if (e.action == "logs") {
      this.openHistorial(e.row.IdTrabajador);
    } else if (e.action == "assigns") {
      this.openAssigns(e.row.IdTrabajador);
    } else if (e.action == "resume") {
      this.openResume(e.row);
    } else if (e.action == "remove") {
      this.askModalBaja(e.row);
    }
  }
  async openHistorial(IdTrabajador: string) {
    await this.dialog
      .open(HistorialReingresosModal, {
        panelClass: ["modal-for-table", "w-full", "lg:w-1/2"],
        data: IdTrabajador,
      })
      .afterClosed()
      .toPromise();
  }
  async openAssigns(IdTrabajador: string) {
    await this.dialog
      .open(HistorialAsignacionesModal, {
        panelClass: ["modal-for-table", "w-full", "lg:w-1/2"],
        data: IdTrabajador,
      })
      .afterClosed()
      .toPromise();
  }
  askModalBaja(row: TrabajadorDTO) {
    this.alerts.ask(this.askModalBajaConfig).then(async (result) => {
      if (result.isConfirmed) {
        this.openModalBaja(row);
      }
    });
  }
  async openModalBaja(row: TrabajadorDTO) {
    const result = await this.dialog
      .open(BajaOperadorFormModal, { panelClass: "w-1/3" })
      .afterClosed()
      .toPromise();

    if (result) {
      this.darDeBaja({ ...result, IdTrabajador: row.IdTrabajador });
    } else {
      this.alerts.error("Cancelada", "Baja cancelada");
    }
  }
  darDeBaja(row: BajaTrabajadorForm) {
    this.service.darDeBaja(row).subscribe(
      (next) => {
        this.alerts.correcta("Eliminado", "Accion realizada correctamente");
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
  downLoad(e, nombre) {
    this.spinner.show();
    this.service.getPdf(e).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        this.downLoadFile(
          response.body,
          contentType,
          "acta_ss_" + nombre + ".pdf"
        );
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      }
    );
  }

  downLoadBaja(e, nombre) {
    this.spinner.show();
    this.service.getPdfBaja(e).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        this.downLoadFile(
          response.body,
          contentType,
          "baja_ss_" + nombre + ".pdf"
        );
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      }
    );
  }
  downLoadFile(data: any, contentType: string, filename: string) {
    const blob = new Blob([data], { type: contentType });
    FileSaver.saveAs(blob, filename);
    this.spinner.hide();
  }


    openUser() {
      const drawerRef = this.drawer.open({
        component: TrabajadorDrawerForm,
        data: { mode: "create", value: {} },
        classDrawer: "w-3/4 xl:w-1/2",
        title: "Trabajador",
        classes: "bg-blueGray-100",
        actions: [
          {
            label: "Cancel",
            action: () => this.drawer.close(),
            buttonClass: "bg-red-600",
          },
          {
            label: "Guardar",
            action: (component: TrabajadorDrawerForm) => component.saveOver(),
            validation: (component: TrabajadorDrawerForm) => component.buttonDisable(),
          },
        ],
      });

      drawerRef.afterClosed$.subscribe((result: any) => {
        this.saveForm(result.data);
      });
    }

    override openEdit(value: any) {
      const drawerRef = this.drawer.open({
        component: TrabajadorDrawerForm,
        data: { mode: "update", value: value },
        classDrawer: "w-3/4 xl:w-1/2",
        title: "Trabajador",
        classes: "bg-blueGray-100",
        actions: [
          {
            label: "Cancel",
            action: () => this.drawer.close(),
            buttonClass: "bg-red-600",
          },
          {
            label: "Actualizar",
            action: (component: TrabajadorDrawerForm) => component.saveOver(),
            validation: (component: TrabajadorDrawerForm) => component.buttonDisable(),
          },
        ],
      });

      drawerRef.afterClosed$.subscribe((result: any) => {
        this.saveForm(result.data);
      });
    }


    openResume(value: any) {
      const drawerRef = this.drawer.open({
        component: TrabajadorResumeComponent,
        data: { mode: "update", value: value },
        classDrawer: "w-3/4 xl:w-1/2",
        title: "Resumen del Trabajador",
        classes: "bg-blueGray-100",
        actions: [
          {
            label: "Cancel",
            action: () => this.drawer.close(),
            buttonClass: "bg-red-600",
          }
        ],
      });

      drawerRef.afterClosed$.subscribe((result: any) => {
        this.saveForm(result.data);
      });
    }
    public tableActionsCC = [
      {
        label: "Nuevo",
        icon: "plus",
        className:
          "text-xs font-bold uppercase px-3 py-2 rounded shadow hover:shadow-md bg-blueGray-600 text-white disabled:opacity-50",
        action: () => this.openUser(),
      },
    ];
}

const tiposEmpleados = [
  "",
  "Chofer",
  "Supervisor",
  "Chofer/Supervisor",
  "Mecanico",
];
function mapperTrabajador(value: TrabajadorDTO): TrabajadorDTO {
  const TipoDesc = tiposEmpleados[value.Tipo] ?? "";

  return { ...value, TipoDesc };
}

function mapperTrabajadorSimple(
  value: TrabajadorSimpleDTO
): TrabajadorSimpleDTO {
  const TipoDesc = tiposEmpleados[value.Tipo] ?? "";

  return { ...value, TipoDesc };
}
